import { inject, onBeforeUnmount } from 'vue';

export function useEventBus() {
  const eventBus = inject('eventBus');

  if (!eventBus) {
    throw new Error('Event bus not provided. Make sure to added it in main.js');
  }

  const registeredListeners = [];

  const on = (event, callback) => {
    eventBus.on(event, callback);
    registeredListeners.push({ event, callback });
  };

  const off = (event, callback) => {
    eventBus.off(event, callback);

    const index = registeredListeners.findIndex(
      listener => listener.event === event && listener.callback === callback
    );
    if (index > -1) {
      registeredListeners.splice(index, 1);
    }
  };

  const emit = (event, data) => {
    eventBus.emit(event, data);
  };

  const once = (event, callback) => {
    eventBus.once(event, callback);
  };

  onBeforeUnmount(() => {
    registeredListeners.forEach(({ event, callback }) => {
      eventBus.off(event, callback);
    });
    registeredListeners.length = 0;
  });

  return { on, off, emit, once };
}
